export const DURATION_HINT = 'Seconds, m:s or h:m:s. Examples: 90, 20:00 (20 min), 3:00:00 (3 h).';

export function parseDuration(value, { min = 1, max = 86400, integer = true } = {}) {
    if (value == null) return null;
    const text = String(value).trim();
    if (!text) return null;
    const parts = text.split(':');
    if (parts.length > 3 || !parts.every((part, index) => (index === parts.length - 1 ? /^\d+(?:\.\d{1,2})?$/ : /^\d+$/).test(part))) return null;
    const numbers = parts.map(Number);
    if (parts.length > 1 && numbers.at(-1) >= 60) return null;
    if (parts.length === 3 && numbers[1] >= 60) return null;
    const seconds = Math.round(numbers.reduce((total, part) => total * 60 + part, 0) * 100) / 100;
    return Number.isFinite(seconds) && seconds >= min && seconds <= max && (!integer || Number.isSafeInteger(seconds)) ? seconds : null;
}

export function formatDurationHuman(value) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) return '—';
    const seconds = Math.round(Number(value) * 100) / 100;
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainder = Math.round(seconds % 60 * 100) / 100;
    return [hours ? `${hours} h` : '', minutes ? `${minutes} min` : '', remainder || (!hours && !minutes) ? `${remainder} s` : ''].filter(Boolean).join(' ');
}


export function formatDurationInput(value) {
    if (value == null || value === '' || !Number.isFinite(Number(value))) return '';
    const seconds = Math.round(Number(value) * 100) / 100;
    if (seconds < 60) return String(seconds);
    const hours = Math.floor(seconds / 3600);
    const minutes = Math.floor(seconds % 3600 / 60);
    const remainder = String(Math.round(seconds % 60 * 100) / 100).padStart(2, '0');
    return hours ? `${hours}:${String(minutes).padStart(2, '0')}:${remainder}` : `${minutes}:${remainder}`;
}
